import getIdentityErrors from 'features/Onboarding/modules/Identity/libs/getIdentityErrors';
import getIdentityStatus from 'features/Onboarding/modules/Identity/libs/getIdentityStatus';
import getQesStatus from 'features/Onboarding/modules/Qes/libs/getQesStatus';
import { ApplicantType, ApplicationType } from 'features/Onboarding/types';

import { State } from '../../machine';
import model from '../../machine/model';
import locales from './locales';
import {
  GetVerificationStep,
  VerificationStatus,
  VerificationStepCategory,
} from './types';

const getIdentityStep: GetVerificationStep = ({
  applicantType,
  applicationType,
  isSasuCreation,
  verificationData,
}) => {
  const idStatus = getIdentityStatus({
    companyUser: verificationData.viewer.companyUser,
  });
  const qesstatus = getQesStatus({
    companyUser: verificationData.viewer.companyUser,
  });

  const isOnboardingHub =
    applicationType === ApplicationType.Standard &&
    applicantType === ApplicantType.AccountHolder;

  const shouldOpenQesModule =
    isOnboardingHub &&
    (idStatus === VerificationStatus.Completed ||
      idStatus === VerificationStatus.Validated) &&
    (qesstatus === VerificationStatus.ToDo ||
      qesstatus === VerificationStatus.Invalid);

  const stepStatus = shouldOpenQesModule ? qesstatus : idStatus;

  const getDescription = () => {
    if (isSasuCreation) {
      return {
        add: locales.id.home.estimatedTime,
      };
    }

    if (!isOnboardingHub) {
      return undefined;
    }

    return shouldOpenQesModule
      ? locales.qes.hub.description
      : locales.id.hub.description;
  };

  const getLabel = () => {
    if (isSasuCreation) {
      return {
        add: locales.id.home.label.review,
        review: locales.id.home.label.review,
      }
    }

    return isOnboardingHub ? locales.id.hub.label : locales.id.home.label
  };

  const getIconName = () => {
    if (!isOnboardingHub) {
      return 'profile';
    }

    return shouldOpenQesModule ? 'shield' : 'auto-capture-on';
  };

  return {
    errors: getIdentityErrors({
      kycDocuments: verificationData.viewer.companyUser.kycDocuments,
      kycReviewError:
        verificationData.viewer.companyUser.lastKycReview?.error ?? null,
      providerReviewError:
        verificationData.viewer.companyUser.kycIdProviderError,
      stepStatus,
    }),
    id: shouldOpenQesModule ? State.QES : State.IDENTITY,
    metadata: {
      category: VerificationStepCategory.PersonalInfo,
      description: getDescription(),
      event: shouldOpenQesModule
        ? model.events.GO_QES()
        : model.events.GO_IDENTITY(),
      iconName: getIconName(),
      isDisabled: isOnboardingHub
        ? false
        : stepStatus === VerificationStatus.Completed ||
        stepStatus === VerificationStatus.Validated,
      label: getLabel(),
    },
    status: stepStatus,
  };
};

export default getIdentityStep;